module.exports = __webpack_public_path__ + "static/media/express.e9b0a5d3.jpg";